import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M480-96 312-264l51-51 81 81v-174h72v174l81-81 51 51zM264-312 96-480l168-168 51 51-81 81h174v72H234l81 81zm432 0-51-51 81-81H552v-72h174l-81-81 51-51 168 168zM444-552v-174l-81 81-51-51 168-168 168 168-51 51-81-81v174z" }, null, -1)
  ])))
}
export default { render: render }